import axios from 'axios'
import { YlSsoManager } from 'yl-sso/openid/YlSsoManager'

export const publicUrl = (process.env.CLIENT_PUBLIC_PATH || process.env.PUBLIC_PATH)!
export const kustomerChatApi = axios.create({ baseURL: publicUrl + 'api' })

export const ylSso = import('yl-sso/authentication').then((ylSso) => {
  return ylSso.initializeAuth({ baseUrl: publicUrl, promptForLoginOnFail: false })
})

kustomerChatApi.interceptors.request.use(async (request) => {
  const { authRequestInterceptor } = await ylSso
  return authRequestInterceptor(request)
})

kustomerChatApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log('[kustomer-chat] KustomerChatApi response rejected:', error)
    const { authResponseErrorInterceptor } = await ylSso
    return authResponseErrorInterceptor(error, kustomerChatApi)
  }
)
